import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
  CircularProgress,
} from "@mui/material";
import PendingIcon from "@mui/icons-material/HourglassEmpty";
import { keyframes } from "@mui/system"; 
import { useSelector } from "react-redux";

// Define keyframes properly for MUI
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const KYCPending = ({ userId, kycStatus }) => {

  const theme=useSelector((data)=>data.themeValue.colors);
  const themeMode=useSelector((data)=>data.themeValue.theme)
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper
        elevation={4}
        sx={{
          p: 5,
          borderRadius: 4,
          textAlign: "center",
          boxShadow: themeMode==="light"?"0px 4px 20px rgba(0, 0, 0, 0.1)":"0px 4px 20px rgba(255, 255, 255, 0.1)",
          backgroundColor:theme.background
        }}
      >
        <Typography variant="h4" fontWeight="bold" sx={{color : theme.text}}gutterBottom>
          KYC Status
        </Typography>

        <Typography
          variant="h6"
          color="warning.main"
          fontWeight="600"
          sx={{ mb: 4 ,color:theme.text}}
        >
          {kycStatus || "Pending"}
        </Typography>

        <Divider sx={{ my: 3 ,backgroundColor:theme.secondary_text_color}} />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            alignItems: "center",
            mt: 3,
          }}
        >
          {/* PAN Card Status */}
          <Box
            sx={{
              width: "100%",
              p: 2,
              border: "1px solid #f0f0f0",
              borderRadius: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor:theme.background,
              // transition: "0.3s",
              // "&:hover": { backgroundColor: "#f5f5f5" },
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold" sx={{color:theme.text}}>
              PAN Card
            </Typography>
            <PendingIcon
              sx={{
                color: "orange",
                animation: `${spin} 2s linear infinite`,
                fontSize: 32,
              }}
            />
          </Box>

          {/* Aadhaar Card Status */}
          <Box
            sx={{
              width: "100%",
              p: 2,
              border: "1px solid #f0f0f0",
              borderRadius: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
               backgroundColor:theme.background,
              // transition: "0.3s",
              // "&:hover": { backgroundColor: "#f5f5f5" },
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold" sx={{color:theme.text}}>
              Aadhaar Card
            </Typography>
            <PendingIcon
              sx={{
                color: "orange",
                animation: `${spin} 2s linear infinite`,
                fontSize: 32,
              }}
            />
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default KYCPending;
